import APIClient from '@/shared/http/clients/api'

const resourceName = 'board'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?arquivado=false&sort=name,asc&size=500`, data, config)
const GetAllAjuizamento = (boolean) => APIClient.get(`${APICore}/${resourceName}/?isAjuizamento=${boolean}&sort=name,asc&size=500`)
const GetAllTipoBoard = (tipoBoard, config = {}) => APIClient.get(`${APICore}/${resourceName}/?tipoBoard=${tipoBoard}&size=500`)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?descricao=${document}&page=${index}&size=${limit}`, config)
const Report = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}/report`, config)
const GetAllProductsBoard = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}/produtos`, config)

const BoardRepository = {
  GetAll,
  GetAllActive,
  GetAllTipoBoard,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  Report,
  GetAllProductsBoard,
  GetAllAjuizamento
}

export default BoardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/board.js